export default __webpack_public_path__ + "static/media/Crypto-Blue-logos-2.16514c76.png";